import type { components } from "./schema";

import { apiClient } from "./client";

export type ThemeResponse = components["schemas"]["ThemeResponse"];

export async function getTheme(): Promise<ThemeResponse> {
  const { data } = await apiClient.get<ThemeResponse>("/api/theme");
  return data;
}
